import auth from "@/auth";
import store from "@/store";

export default {
  path: 'user/:userId',
  components: {
    default: () => import(/* webpackChunkName: "user" */ '@/components/wrapper.vue'),
    menu: () => import(/* webpackChunkName: "user" */ './menu.vue'),
  },
  beforeEnter: function (to, from, next) {
    if (! auth.checkAccess('general', ['admin', 'customer'])) {
      return next(store.state.user.homepage)
    }

    next()
  },
  meta: {
    section: 'user'
  },
  children: [
    {
      path: '/',
      name: 'user.profile',
      component: () => import(/* webpackChunkName: "user" */ './profile.vue'),
    },
    {
      path: 'organisations',
      name: 'user.organisations',
      component: () => import(/* webpackChunkName: "user" */ './organisations.vue'),
    }
  ],
};

